/**
 * Production: same-origin `/api/...` (Firebase Hosting → Functions).
 * Development: REACT_APP_API_BASE_URL veya REACT_APP_CAMPAIGN_AI_URL kökü veya http://localhost:5055.
 */

export function getApiBase() {
  if (process.env.NODE_ENV === 'development') {
    const explicit = String(process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');
    if (explicit) return explicit;
    const legacy = String(process.env.REACT_APP_CAMPAIGN_AI_URL || '')
      .trim()
      .replace(/\/api\/campaign-ai\/?$/i, '')
      .replace(/\/+$/, '');
    if (legacy) return legacy;
    return 'http://localhost:5055';
  }
  return '';
}

export function apiUrl(path) {
  const p = String(path || '');
  const normalized = p.startsWith('/') ? p : `/${p}`;
  const base = getApiBase();
  if (!base) return normalized;
  return `${base.replace(/\/+$/, '')}${normalized}`;
}

/** gunsonuWhatsappSend — production: Hosting rewrite `/gunsonu-whatsapp-send`. */
export function gunsonuWhatsappSendUrl() {
  if (process.env.NODE_ENV === 'development') {
    const explicit = String(process.env.REACT_APP_GUNSONU_WHATSAPP_URL || '').trim().replace(/\/+$/, '');
    if (explicit) return explicit;
    return 'https://europe-west1-ukba-kasa-34bd3.cloudfunctions.net/gunsonuWhatsappSend';
  }
  return '/gunsonu-whatsapp-send';
}

/** gunsonuBranchCompare — production: Hosting rewrite `/gunsonu-branch-compare`. */
export function gunsonuBranchCompareUrl() {
  if (process.env.NODE_ENV === 'development') {
    const explicit = String(process.env.REACT_APP_GUNSONU_COMPARE_URL || '').trim().replace(/\/+$/, '');
    if (explicit) return explicit;
    return 'https://europe-west1-ukba-kasa-34bd3.cloudfunctions.net/gunsonuBranchCompare';
  }
  return '/gunsonu-branch-compare';
}

/** bankingBackfillNow — production: Hosting rewrite `/banking-backfill-now` → Cloud Function. */
export function bankingBackfillNowUrl() {
  if (process.env.NODE_ENV === 'development') {
    const explicit = String(process.env.REACT_APP_BANKING_BACKFILL_URL || '').trim().replace(/\/+$/, '');
    if (explicit) return explicit;
    return 'https://europe-west1-ukba-kasa-34bd3.cloudfunctions.net/bankingBackfillNow';
  }
  return '/banking-backfill-now';
}

/** bankingSyncNow — production: Hosting rewrite `/banking-sync-now` → Cloud Function. */
export function bankingSyncNowUrl(subeId, { allBranches = false, force = false } = {}) {
  const params = new URLSearchParams();
  params.set('subeId', String(subeId || '').trim());
  if (allBranches) params.set('allBranches', 'true');
  if (force) params.set('force', 'true');
  const query = params.toString();
  if (process.env.NODE_ENV === 'development') {
    const explicit = String(process.env.REACT_APP_BANKING_SYNC_URL || '').trim().replace(/\/+$/, '');
    if (explicit) {
      return explicit.includes('?') ? `${explicit}&${query}` : `${explicit}?${query}`;
    }
    return `https://bankingsyncnow-uedxetigoa-ew.a.run.app?${query}`;
  }
  return `/banking-sync-now?${query}`;
}
